import { Handle, Position } from "@xyflow/react";
import styles from "./WorkflowNode.module.css";

export default function LinkHandles({ prefix = "link" }: { prefix?: string }) {
  return (
    <>
      <Handle
        type="source"
        position={Position.Top}
        id={`${prefix}-top`}
        className={styles.linkHandle}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id={`${prefix}-bottom`}
        className={styles.linkHandle}
      />
      <Handle
        type="source"
        position={Position.Left}
        id={`${prefix}-left`}
        className={styles.linkHandle}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={`${prefix}-right`}
        className={styles.linkHandle}
      />
    </>
  );
}
